import { WjFlexGrid } from '@grapecity/wijmo.angular2.grid';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';
import { OnDestroy, ElementRef, ViewChildren, QueryList, Directive } from '@angular/core';
import { FlexGrid, SelectionMode, CellType } from '@grapecity/wijmo.grid';
import { PlessViewHelper } from '../../shared/pless-view-helper';
import { KYMW00Model } from './kymw00.model';
import { GoodsLockService } from './api-services/goods-lock.service';
import { PlanGoodsLockService } from './api-services/plan-goods-lock.service';
import { CatalogLockService } from './api-services/catalog-lock.service';
import { PageLockService } from './api-services/page-lock.service';
import { PlessViewUtilsSub } from './pless-view-utils-sub.service';
import { DragRef, Point } from '@angular/cdk/drag-drop';

/**
 * PlessViewHelperの拡張クラス
 *
 * @export PlessViewHelperSub
 * @class PlessViewHelperSub
 */
@Directive()
export class PlessViewHelperSub extends PlessViewHelper implements OnDestroy {
  @ViewChildren(WjInputDate) public wjInputDateList: QueryList<WjInputDate>;
  @ViewChildren(WjFlexGrid) public wjFlexGridList: QueryList<WjFlexGrid>;

  public parent: any = null;
  private _componentName = String('');
  public parentView: string = null;
  public popupView: string = null;
  public iInputVOArray: any = null;

  public contextMenuForcedEnabledKeys: Array<string> = new Array<string>();
  public contextMenuForcedEnabledVals: Array<string> = new Array<string>();

  private _goodsLockService: GoodsLockService;
  private _planGoodsLockService: PlanGoodsLockService;
  private _catalogLockService: CatalogLockService;
  private _pageLockService: PageLockService;

  // ロック部品実行時に登録した各Functionの格納用
  protected goodsSuccessFunction: Function = null;
  protected goodsFaultFunction: Function = null;
  protected planGoodsSuccessFunction: Function = null;
  protected planGoodsFaultFunction: Function = null;
  protected catalogSuccessFunction: Function = null;
  protected catalogFaultFunction: Function = null;
  protected pageSuccessFunction: Function = null;
  protected pageFaultFunction: Function = null;

  /**
   * 日付選択制限(下限)
   *
   * @type {Date}
   * @memberof PlessViewHelperSub
   */
  public minDate: Date = new Date('1900-01-01');

  /**
   * 日付選択制限(下限)
   *
   * @type {Date}
   * @memberof PlessViewHelperSub
   */
  public maxDate: Date = new Date('2100-12-31');

  public initLock = String('');

  /**
   *Creates an instance of PlessViewHelperSub.
   * @param {KYMW00Model} sharedModel 共通モデルクラス
   * @memberof PlessViewHelperSub
   */
  constructor(
    public sharedModel: KYMW00Model,
  ) {
    super();
  }

  /**
   * 画面終了時処理
   *
   * @memberof PlessViewHelperSub
   */
  ngOnDestroy() {
    this.deletePopUp(this.popupView);
  }

  /**
   * 商品ロックサービスを設定する
   *
   * @memberof PlessViewHelperSub
   */
  set goodsLockService(service: GoodsLockService) {
    this._goodsLockService = service;
  }

  /**
   * 商品ロックサービスを取得する
   *
   * @memberof PlessViewHelperSub
   */
  get goodsLockService() {
    return this._goodsLockService;
  }

  /**
   * 企画商品ロックサービスを設定する
   *
   * @memberof PlessViewHelperSub
   */
  set planGoodsLockService(service: PlanGoodsLockService) {
    this._planGoodsLockService = service;
  }

  /**
   * 企画商品ロックサービスを取得する
   *
   * @memberof PlessViewHelperSub
   */
  get planGoodsLockService() {
    return this._planGoodsLockService;
  }

  /**
   * 企画ロックサービスを設定する
   *
   * @memberof PlessViewHelperSub
   */
  set catalogLockService(service: CatalogLockService) {
    this._catalogLockService = service;
  }

  /**
   * 企画ロックサービスを取得する
   *
   * @memberof PlessViewHelperSub
   */
  get catalogLockService() {
    return this._catalogLockService;
  }

  /**
   * ページロックサービスを設定する
   *
   * @memberof PlessViewHelperSub
   */
  set pageLockService(service: PageLockService) {
    this._pageLockService = service;
  }

  /**
   * ページロックサービスを取得する
   *
   * @memberof PlessViewHelperSub
   */
  get pageLockService() {
    return this._pageLockService;
  }

  /**
   * parentを設定し、各画面の編集モードリストに追加
   *
   * @memberof PlessViewHelperSub
   */
    public set componentName(componentName: string) {
      this._componentName = componentName;
      this.popupView = componentName.substring(0, 8);
      if (this.parent != null) {
        this.parentView = this.parent.componentName.substr(0, 8);
        if (this.parentView === 'KYMW1002' && this.popupView !== 'KYMW1000') {
          this.sharedModel.kymw1001Model.setScreenModeOnNowFunc(this.popupView.substring(0, 8)); // funcIDの桁数
        }
        this.sharedModel.kymw1001Model.formReadOnlyMode.
          set(this.popupView, this.sharedModel.kymw1001Model.formReadOnlyMode.get(this.parentView));
      } else {
        // FIXME: shuto add 新しいメニューから開く場合の暫定対応（問題がないか確認が必要）
        // formReadOnlyModeが何を意味しているのかよく分からないので、いったん、'KYMW1002'の値を取得してセットするようにした.
        if (this.popupView !== 'KYMW1000') {
          this.sharedModel.kymw1001Model.setScreenModeOnNowFunc(this.popupView.substring(0, 8)); // funcIDの桁数
        }
        this.sharedModel.kymw1001Model.formReadOnlyMode.
          set(this.popupView, this.sharedModel.kymw1001Model.formReadOnlyMode.get('KYMW1002'));
      }
      const winIndex: number = this.getWinIndex(this.popupView);
  
      if (winIndex === -1) {
        this.sharedModel.popUpWinList.push(this.popupView);
      }
      if (this.popupView !== 'KYMW1000' && this.popupView !== 'KYMW1002') {
        // 権限による画面項目の活性/非活性設定
        setTimeout(() => {
          this.setScreenMode(this.initLock, true);
        });
      }
    }
  
  /**
   * 親コンポーネント名取得
   *
   * @memberof PlessViewHelperSub
   */
  public get componentName(): string {
    return this._componentName;
  }

  /**
   * 権限取得メソッド
   *
   * @param {string} [funcId=this.componentName.substr(0, 8)] 画面ID
   * @returns {string} 0：使用不可、1：閲覧のみ、2：フルコントロール可能（帳票出力、更新）
   * @memberof PlessViewHelperSub
   */
  public getFuncPermission(funcId: string = this.componentName.substr(0, 8)): string {
    for (let i = Number(0); i < this.sharedModel.kymw1001Model.permissionList.length; i++) {
      if (this.sharedModel.kymw1001Model.permissionList[i].FuncID === funcId) {
        return this.sharedModel.kymw1001Model.permissionList[i].EnableMode;
      }
    }
    return this.sharedModel.FUNC_PERMISSION_FULLCONTROL;
  }

  /**
   * コントロール活性・非活性制御
   *
   * @param {*} el 対象コントロール
   * @param {boolean} value 活性・非活性フラグ
   * @memberof PlessViewHelperSub
   */
  public plessEnabled(el: any, value: boolean): void {
    // 活性制御を行うエレメントを取得する
    let targetElement;
    let wijmoflag = false;
    if (el instanceof WjInputDate || el instanceof WjFlexGrid) {
      targetElement = el.hostElement;
      wijmoflag = true;
    } else {
      targetElement = this.getTargetElement(el);
    }

    // elementが想定外のものの場合は処理を中断する
    if (targetElement == null) {
      return;
    }

    let forcedEnabledMode = targetElement.getAttribute('forcedEnabledMode');
    // 取得したforcedEnabledModeがnull,undefine,'null'(文字列のnull)だったら空に変換
    if (PlessViewUtilsSub.isEmptyArray(forcedEnabledMode) || forcedEnabledMode === 'null') {
      forcedEnabledMode = '';
    }

    const formReadOnly: boolean = this.sharedModel.kymw1001Model.formReadOnlyMode.get(this.popupView);

    if (wijmoflag) {
      if (formReadOnly === true) {
        switch (forcedEnabledMode) {
          case 'false':
          case '':
            el.isDisabled = true;
            break;
          case 'true':
            el.isDisabled = false;
            break;
          case 'none':
          default:
            el.isDisabled = !value;
            break;
        }
      } else {
        switch (forcedEnabledMode) {
          case 'false':
            el.isDisabled = true;
            break;
          case 'true':
            el.isDisabled = false;
            break;
          case 'none':
          case '':
          default:
            el.isDisabled = !value;
            break;
        }
      }
    } else {
      if (formReadOnly === true) {
        switch (forcedEnabledMode) {
          case 'false':
          case '':
            targetElement.disabled = true;
            break;
          case 'true':
            targetElement.disabled = false;
            break;
          case 'none':
          default:
            targetElement.disabled = !value;
            break;
        }
      } else {
        switch (forcedEnabledMode) {
          case 'false':
            targetElement.disabled = true;
            break;
          case 'true':
            targetElement.disabled = false;
            break;
          case 'none':
          case '':
          default:
            targetElement.disabled = !value;
            break;
        }
      }
    }
  }

  /**
   * 活性制御対象のエレメントを取得する
   *
   * @private
   * @param {*} el
   * @returns {*}
   * @memberof PlessViewHelperSub
   */
  private getTargetElement(el: any): any {
    if (el.nativeElement != null) {
      if (el.nativeElement instanceof HTMLInputElement ||
        el.nativeElement instanceof HTMLTextAreaElement ||
        el.nativeElement instanceof HTMLSelectElement ||
        el.nativeElement instanceof HTMLButtonElement) {
        return el.nativeElement;
      }
    }
    if (el instanceof HTMLInputElement ||
      el instanceof HTMLTextAreaElement ||
      el instanceof HTMLSelectElement ||
      el instanceof HTMLButtonElement) {
      return el;
    } else {
      // 共通部品の場合、子要素を取得
      if (el.elementRef != null) {
        for (const child of el.elementRef.nativeElement.children) {
          if (child instanceof HTMLInputElement ||
            child instanceof HTMLTextAreaElement ||
            child instanceof HTMLSelectElement ||
            child instanceof HTMLButtonElement) {
            return child;
          } else {
            return this.getTargetElement(child);
          }
        }
      } else {
        // CheckBox,RadioButton部品の場合、孫要素を取得
        if (el.children) {
          for (const child of el.children) {
            if (child instanceof HTMLInputElement ||
              child instanceof HTMLTextAreaElement ||
              child instanceof HTMLSelectElement ||
              child instanceof HTMLButtonElement) {
              return child;
            } else {
              return this.getTargetElement(child);
            }
          }
        }
      }
    }

    return null;
  }

  /**
   * 活性制御用コンテキストメニュー初期化処理
   *
   * @param {*} item メニュー項目
   * @param {string} forcedEnabled 強制活モード
   * @memberof PlessViewHelperSub
   */
  public initForcedEnabledForContextMenuItemByScreenMode(item: any, forcedEnabled = 'false'): void {
    this.contextMenuForcedEnabledKeys.push(item.header);

    switch (forcedEnabled) {
      case '':
      case 'false':
        this.contextMenuForcedEnabledVals.push('false');
        break;
      case 'true':
        this.contextMenuForcedEnabledVals.push('true');
        break;
      case 'none':
      default:
        this.contextMenuForcedEnabledVals.push('none');
    }
  }

  /**
   * コンテキストメニュー項目活性制御
   *
   * @param {*} item メニュー項目
   * @param {boolean} value （true:活性、false:非活性）
   * @returns {boolean}
   * @memberof PlessViewHelperSub
   */
  public setContextMenuEnabled(item: any, value: boolean): boolean {
    const manage = this.sharedModel.kymw1001Model;
    if (manage.topFuncReadOnlyMode === false || this.getContextMenuItemForcedEnabledMode(item.caption) === 'none') {
      return value;
    } else if (this.getContextMenuItemForcedEnabledMode(item.caption) === 'true') {
      return true;
    } else if (this.getContextMenuItemForcedEnabledMode(item.caption) === 'false') {
      return false;
    }
  }

  /**
   * コンテキストメニュー強制活性モード取得
   *
   * @private
   * @param {string} caption 項目名
   * @returns {string}
   * @memberof PlessViewHelperSub
   */
  private getContextMenuItemForcedEnabledMode(caption: string): string {
    let result = String('false');
    for (let i = Number(0); i < this.contextMenuForcedEnabledKeys.length; i++) {
      if (this.contextMenuForcedEnabledKeys[i] === caption) {
        result = this.contextMenuForcedEnabledVals[i];
        break;
      }
    }
    return result;
  }

  /**
   * 画面起動時に呼出元画面からパラメータがＮＵＬＬではない場合呼ばれる。
   *
   * @protected
   * @memberof PlessViewHelperSub
   */
  protected inputParameterSetting(): void {
  }

  /**
   * 呼出元画面からインプットパラメータを取得する
   * 必要に応じて実装ＶｉｅｗＨｅｌｐｅｒ側でＯｖｅｒｒｉｄｅする
   * （呼出元画面から呼ばれる）
   *
   * @param {*} inputVO Array インプットＶＯ（IValueObject）
   * @memberof PlessViewHelperSub
   */
  public setInputVO(inputVO: any): void {
  }

  /**
   * 画面初期化時、権限による画面モード(更新可能/閲覧のみ)の制御を行う
   * init_loadの完了後、一括で画面モード処理の反映を行う
   *
   * @param readOnly 		"true" =画面を閲覧モードにする
   *                 		"false"=画面を更新可能モードにする
   *                 		""     =ユーザ権限により更新/閲覧モードを制御する
   */
  public setScreenMode(readOnly = '', initFlag = false): void {
    if (readOnly === '') {
      // 権限によって更新可能/閲覧モードを設定
      if (this.sharedModel.kymw1001Model.formReadOnlyMode.has(this.popupView) === true) {
        readOnly = this.sharedModel.kymw1001Model.formReadOnlyMode.get(this.popupView)?.toString();
      } else {
        readOnly = this.sharedModel.kymw1001Model.topFuncReadOnlyMode.toString();
      }
    }

    if (readOnly === 'true' || this.sharedModel.kymw1001Model.topFuncReadOnlyMode === true) {
      // 強制的に閲覧モードに設定
      this.setEnabledValue(this, true, initFlag);
    } else {
      // 強制的に更新可能モードに設定
      this.setEnabledValue(this, false, initFlag);
    }
  }

  /**
   * view(mxml)上の各画面コントロールの画面モードおよびenabled属性を再帰的に初期化する
   *
   * @param targetObject	処理対象のコンポーネントの親オブジェクト（トップはmxml）
   * @param readOnly		閲覧モードかどうかのフラグ（true：閲覧モード／false：更新モード）
   *
   */
  private setEnabledValue(targetObject: any, readOnly: boolean, initFlag = false): void {
    if (targetObject.elementRef === undefined)
      return;

    // viewのルート要素の子要素を配列に取得
    const childObjects: any = targetObject.elementRef.nativeElement.
      querySelectorAll('input, select, textarea, button');

    // 子要素を１つずつ取り出して処理
    childObjects.forEach(childObject => {
      let memuFlag = false;
      for (const objectClass of childObject.classList) {
        if (objectClass === 'menubar') {
          this.setMenuItemEnabledMode(childObject, readOnly);
          memuFlag = true;
          break;
        }
      }
      if (!memuFlag) {

        const targetElement = this.getTargetElement(childObject);

        if (childObject.getAttribute('id') != null) {
          let enabledOnDesign: boolean = null;
          if (initFlag === false) {
            if (readOnly !== true) {
              // 一旦すべての子要素の disabled を false に・・
              // 『活性』
              targetElement.disabled = false;
            }
          } else {
            // 画面初期表示時のenabled（画面デザイン時のenabled）を保存
            enabledOnDesign = !targetElement.disabled;
          }

          // 子要素のEnabledを制御する
          let forcedEnabledMode = childObject.getAttribute('forcedEnabledMode');
          // 取得したforcedEnabledModeがnull,undefine,'null'(文字列のnull)だったら空に変換
          if (PlessViewUtilsSub.isEmptyArray(forcedEnabledMode) || forcedEnabledMode === 'null') {
            forcedEnabledMode = '';
          }

          switch (forcedEnabledMode) {
            case 'true':
              // 『活性』
              targetElement.removeAttribute('disabled');
              break;
            case 'false':
              // 『非活性』
              targetElement.disabled = true;
              break;
            case 'none':
            case '':
              if (readOnly === true) {
                // 『非活性』
                targetElement.disabled = true;
              } else {
                // 『活性』
                targetElement.removeAttribute('disabled');
              }
              break;
          }
          if (initFlag === true && enabledOnDesign === false) {
            // 初期表示時かつデザイン時のenabledが falseの場合は
            // enabledをfalseに設定
            targetElement.disabled = true;
          }
        }
        if (childObject instanceof HTMLInputElement || childObject instanceof HTMLTextAreaElement){
          targetElement.setAttribute('autocomplete','off');
        }
      }
    });

    // wijmoのforcedEnabledModeの処理
    this.setForceEnabledModeForWijimo(readOnly, initFlag);
  }

  /**
   * 引数で渡された画面コンロトール(control)に紐づくメニュー項目の
   * 画面モードおよびenabled属性の初期化を行う
   *
   * @private
   * @param {HTMLDivElement} control 画面コントロール
   * @param {boolean} readOnly 画面モード(true：閲覧のみ/false：更新可能)
   * @memberof PlessViewHelperSub
   */
  private setMenuItemEnabledMode(control: HTMLDivElement, readOnly: boolean): void {
    const forcedEnableModeForMenuItem: string = control.getAttribute('forcedEnabledMode');

    // 対象のコントロールのカスタムメニュー項目がある場合は処理
    if (control.children.length > 0) {
      for (let i = Number(0); i < control.children.length; i++) {

        // 一旦すべてのメニュー項目の enabled=true に設定する
        // control.children[i].enabled = true;
        control.children[i].removeAttribute('disabled');
        if (readOnly === true) {
          // 閲覧モードの場合
          switch (forcedEnableModeForMenuItem) {
            case 'true':
              control.children[i].removeAttribute('disabled');
              break;
            case 'false':
            case '':
              control.children[i].setAttribute('disabled', '');
              break;
            case 'none':
              break;
          }
        }
      }
    }
  }

  /**
   * 指定したポップアップウィンドウをリストから削除する。
   * ※リムーブ自体は行われないので、注意。
   *
   * @private
   * @param {string} targetWin 閉じる画面ID
   * @memberof PlessViewHelperSub
   */
  private deletePopUp(targetWin: string): void {
    for (let i = Number(0); i < this.sharedModel.popUpWinList.length; i++) {
      if (this.sharedModel.popUpWinList[i] === targetWin) {
        this.sharedModel.popUpWinList.splice(i, 1);
        break;
      }
    }
  }

  /**
   * 指定した型と一致するポップアップが開かれているかチェックする。</br>
   * 開かれていた場合は、保持配列の該当ポップアップのインデックスを返す。
   *
   * @private
   * @param {string} className チェックする画面ID
   * @returns {number} インデックス値
   * @memberof PlessViewHelperSub
   */
  private getWinIndex(className: string): number {
    let winIndex = Number(-1);
    for (let i = Number(0); i < this.sharedModel.popUpWinList.length; i++) {
      if (this.sharedModel.popUpWinList[i] === className) {
        winIndex = i;
        break;
      }
    }
    return winIndex;
  }

  /**
   * 指定した型と一致するポップアップが開かれているかチェックする。
   *
   * @param {string} className チェックする画面ID
   * @returns {boolean} TRUE:開かれている、FALSE:開かれていない
   * @memberof PlessViewHelperSub
   */
  public isOpened(className: string): boolean {
    for (let i = Number(0); i < this.sharedModel.popUpWinList.length; i++) {
      if (this.sharedModel.popUpWinList[i] === className) {
        return true;
      }
    }
    return false;
  }

  /**
   * 商品ロック
   *
   * @param {string} mode REGIST：ロック登録／RELEASE：ロック解除／CHECK：チェック
   * @param {string} pCode Pコード（単品：Stringのみ）
   * @param {Function} [successFunc=null] ロック成功時、実行するメソッド
   * @param {Array<any>} [successParam=null] ロック成功時、実行するメソッドの引数
   * @param {Function} [faultFunc=null] ロック失敗時、実行するメソッド
   * @param {Array<any>} [faultParam=null] ロック失敗時、実行するメソッドの引数
   * @param {boolean} [viewControl=true] ロック処理終了時、画面制御(活性非活性)をtrue:行う／false:行わない
   * @param {string} [lockerId=null] ロック処理を実行したユーザID
   * @returns {void}
   * @memberof PlessViewHelperSub
   */
  public LockUtilForGoods(mode: string, pCode: string, successFunc: Function = null, successParam: Array<any> = null,
    faultFunc: Function = null, faultParam: Array<any> = null, viewControl = true, lockerId: string = null): void {
    if (PlessViewUtilsSub.isEmpty(pCode)) {
      return;
    }

    if (this.sharedModel.kymw1001Model.topFuncReadOnlyMode) {
      if (faultFunc != null) {
        faultFunc(faultParam);
      }
      return;
    }

    // パラメータ設定
    const vo: any = new Object();
    vo.pCode = pCode;
    vo.formId = this.popupView;
    vo.userId = (mode === 'RELEASE' && lockerId) ? lockerId : this.sharedModel.kymw1001Model.loginUserInfo.UserID;
    vo.viewHelper = this;
    vo.successFunc = successFunc;
    vo.successParam = successParam;
    vo.faultFunc = faultFunc;
    vo.faultParam = faultParam;
    vo.viewControl = viewControl;
    vo.checkOnly = '0';

    // ロックイベント発行
    if (mode === 'REGIST') {
      this.goodsLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_PLAN_GOODS_REGIST);
    } else if (mode === 'RELEASE') {
      this.goodsLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_PLAN_GOODS_RELEASE);
    } else {
      vo.checkOnly = '1';
      this.goodsLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_PLAN_GOODS_CHECK);
    }
  }

  /**
   * 企画商品ロック
   *
   * @param {string} mode REGIST：ロック登録／RELEASE：ロック解除／CHECK：チェック
   * @param {string} orderCode 受注コード
   * @param {string} mediumType 媒体区分
   * @param {*} pCode Pコード（単品：String／複数：ArrayCollection）
   * @param {Function} [successFunc=null] ロック成功時、実行するメソッド
   * @param {*} [successParam=null] ロック成功時、実行するメソッドの引数
   * @param {Function} [faultFunc=null] ロック失敗時、実行するメソッド
   * @param {*} [faultParam=null] ロック失敗時、実行するメソッドの引数
   * @param {boolean} [viewControl=true] ロック処理終了時、画面制御(活性非活性)をtrue:行う／false:行わない
   * @param {string} [lockerId=null] ロック処理を実行したユーザID
   * @returns {void}
   * @memberof PlessViewHelperSub
   */
  public LockUtilForPlanGoods(mode: string, orderCode: string, mediumType: string, pCode: any, successFunc: Function = null,
    successParam: any = null, faultFunc: Function = null, faultParam: any = null, viewControl = true, lockerId: string = null): void {

    let pCodeArray: Array<string> = new Array<string>();

    if (PlessViewUtilsSub.isEmpty(orderCode)) {
      return;
    }
    if (PlessViewUtilsSub.isEmpty(mediumType)) {
      return;
    }
    if (pCode instanceof Array) {
      if (PlessViewUtilsSub.isEmptyArray(pCode)) {
        return;
      }

      pCodeArray = pCode;
    } else {
      if (PlessViewUtilsSub.isEmpty(pCode)) {
        return;
      }

      pCodeArray.push(pCode);
    }

    if (this.sharedModel.kymw1001Model.topFuncReadOnlyMode === true) {
      if (faultFunc != null) {
        faultFunc(faultParam);
      }
      return;
    }

    // パラメータ設定
    const vo: any = new Object();
    vo.orderCode = orderCode;
    vo.mediumType = mediumType;
    vo.pCode = pCodeArray;
    vo.formId = this.popupView;
    vo.userId = (mode === 'RELEASE' && lockerId) ? lockerId : this.sharedModel.kymw1001Model.loginUserInfo.UserID;
    vo.viewHelper = this;
    vo.successFunc = successFunc;
    vo.successParam = successParam;
    vo.faultFunc = faultFunc;
    vo.faultParam = faultParam;
    vo.viewControl = viewControl;
    vo.checkOnly = '0';

    // ロックイベント発行
    if (mode === 'REGIST') {
      this.planGoodsLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_PLAN_GOODS_REGIST);
    } else if (mode === 'RELEASE') {
      this.planGoodsLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_PLAN_GOODS_RELEASE);
    } else {
      vo.checkOnly = '1';
      this.planGoodsLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_PLAN_GOODS_CHECK);
    }
  }

  /**
   * 企画ロック
   *
   * @param {string} mode ロック処理を実行した画面ID
   * @param {string} orderCode REGIST：ロック登録／RELEASE：ロック解除／CHECK：チェック
   * @param {string} mediumType 受注コード
   * @param {Function} [successFunc=null] 媒体区分
   * @param {Object} [successParam=null] ロック成功時、実行するメソッド
   * @param {Function} [faultFunc=null] ロック成功時、実行するメソッドの引数
   * @param {Array<any>} [faultParam=null] ロック失敗時、実行するメソッド
   * @param {boolean} [viewControl=true] ロック処理終了時、画面制御(活性非活性)をtrue:行う／false:行わない
   * @param {boolean} [allMediumFlag=false] true：全媒体をロック登録／false：対象の一媒体のみロック登録（登録時のみ有効）
   * @param {string} [lockerId=null] ロック処理を実行したユーザID
   * @returns {void}
   * @memberof PlessViewHelperSub
   */
  public LockUtilForCatalog(mode: string, orderCode: string, mediumType: string, successFunc: Function = null, successParam: Object = null,
    faultFunc: Function = null, faultParam: Array<any> = null, viewControl = true, allMediumFlag = false, lockerId: string = null): void {
    if (orderCode === '') {
      return;
    }
    if (mediumType === '') {
      return;
    }

    if (this.sharedModel.kymw1001Model.topFuncReadOnlyMode === true) {
      if (faultFunc != null) {
        faultFunc(faultParam);
      }
      return;
    }

    // パラメータ設定
    const vo: any = new Object();
    vo.orderCode = orderCode;
    vo.mediumType = mediumType;
    vo.formId = this.popupView;
    vo.userId = (mode === 'RELEASE' && lockerId) ? lockerId : this.sharedModel.kymw1001Model.loginUserInfo.UserID;
    vo.viewHelper = this;
    vo.successFunc = successFunc;
    vo.successParam = successParam;
    vo.faultFunc = faultFunc;
    vo.faultParam = faultParam;
    vo.viewControl = viewControl;
    vo.allMediumFlag = allMediumFlag;
    vo.checkOnly = '0';

    // ロックイベント発行
    if (mode === 'REGIST') {
      this.catalogLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_CATALOG_REGIST);
    } else if (mode === 'REGIST_WITH_FORCE_RELEASE') {
      this.catalogLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_CATALOG_REGIST_WITH_FORCE_RELEASE);
    } else if (mode === 'RELEASE') {
      this.catalogLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_CATALOG_RELEASE);
    } else {
      vo.checkOnly = '1';
      this.catalogLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_CATALOG_CHECK);
    }
  }

  /**
   * ページロック
   *
   * @param {string} mode REGIST：ロック登録／RELEASE：ロック解除／CHECK：チェック
   * @param {string} orderCode 受注コード
   * @param {string} mediumType 媒体区分
   * @param {number} pageId ページID
   * @param {Function} [successFunc=null] ロック成功時、実行するメソッド
   * @param {Object} [successParam=null] ロック成功時、実行するメソッドの引数
   * @param {Function} [faultFunc=null] ロック失敗時、実行するメソッド
   * @param {Array<any>} [faultParam=null] ロック失敗時、実行するメソッドの引数
   * @param {boolean} [viewControl=true] ロック処理終了時、画面制御(活性非活性)をtrue:行う／false:行わない
   * @param {string} [lockerId=null] ロック処理を実行したユーザID
   * @returns {void}
   * @memberof PlessViewHelperSub
   */
  public LockUtilForPage(mode: string, orderCode: string, mediumType: string, pageId: number, successFunc: Function = null,
    successParam: Object = null, faultFunc: Function = null, faultParam: Array<any> = null, viewControl = true, lockerId: string = null): void {
    if (orderCode === '') {
      return;
    }
    if (mediumType === '') {
      return;
    }
    if (pageId < 1) {
      return;
    }

    if (this.sharedModel.kymw1001Model.topFuncReadOnlyMode === true) {
      if (faultFunc != null) {
        faultFunc(faultParam);
      }
      return;
    }

    // パラメータ設定
    const vo: any = new Object();
    vo.orderCode = orderCode;
    vo.mediumType = mediumType;
    vo.pageId = pageId;
    vo.formId = this.popupView;
    vo.userId = (mode === 'RELEASE' && lockerId) ? lockerId : this.sharedModel.kymw1001Model.loginUserInfo.UserID;
    vo.viewHelper = this;
    vo.successFunc = successFunc;
    vo.successParam = successParam;
    vo.faultFunc = faultFunc;
    vo.faultParam = faultParam;
    vo.viewControl = viewControl;
    vo.checkOnly = '0';

    // ロックイベント発行
    if (mode === 'REGIST') {
      this.pageLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_PAGE_REGIST);
    } else if (mode === 'RELEASE') {
      this.pageLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_PAGE_RELEASE);
    } else {
      vo.checkOnly = '1';
      this.pageLockService.execute(this.sharedModel, vo, this.sharedModel.EVENT_LOCK_PAGE_CHECK);
    }
  }

  /**
   * ngOnInit内で設定するplessEnabledの処理を記述するメソッド
   */
  public plessEnabledSetting(): void {
  }

  /**
   * WijmoのforcedEnabledModeの処理
   *
   * @param readOnly		閲覧モードかどうかのフラグ（true：閲覧モード／false：更新モード）
   * @param initFlag 初回フラグ
   */
  private setForceEnabledModeForWijimo(readOnly: boolean, initFlag: boolean) {
    this.wjInputDateList.forEach((inputDate: WjInputDate) => {
      this.setDisabledForWjInputDate(inputDate, readOnly, initFlag);
    });
    this.wjFlexGridList.forEach((flexGrid: WjFlexGrid) => {
      this.setDisabledForWjFlexGrid(flexGrid, readOnly, initFlag);
    });
  }

  /**
   * wijmoの部品へのdisabled付与処理
   *
   * @param inputDate wijmoの部品
   * @param readOnly 閲覧モードかどうかのフラグ（true：閲覧モード／false：更新モード）
   * @param initFlag 初回フラグ
   */
  private setDisabledForWjInputDate(inputDate: WjInputDate, readOnly: boolean, initFlag: boolean) {
    if (inputDate.hostElement) {
      let enabledOnDesign: boolean = null;
      const forcedEnabledMode = inputDate.hostElement.getAttribute('forcedEnabledMode')
        ? inputDate.hostElement.getAttribute('forcedEnabledMode') : '';
      if (initFlag === false) {
        if (readOnly !== true) {
          // 一旦すべての子要素の disabled を false に・・
          // 『活性』
          inputDate.isDisabled = false;
        }
      } else {
        // 画面初期表示時のenabled（画面デザイン時のenabled）を保存
        enabledOnDesign = !inputDate.isDisabled;
      }

      // 子要素のEnabledを制御する
      switch (forcedEnabledMode) {
        case 'true':
          // 『活性』
          inputDate.isDisabled = false;
          break;
        case 'false':
          // 『非活性』
          inputDate.isDisabled = true;
          break;
        case '':
        case 'none':
          if (readOnly === true) {
            // 『非活性』
            inputDate.isDisabled = true;
          } else {
            // 『活性』
            inputDate.isDisabled = false;
          }
          break;
      }
      if (initFlag === true && enabledOnDesign === false) {
        // 初期表示時かつデザイン時のenabledが falseの場合は
        // enabledをfalseに設定
        inputDate.isDisabled = true;
      }
    }
  }

  /**
   * wijmoの部品へのdisabled付与処理
   *
   * @param wjFlexGrid wijmoの部品
   * @param readOnly 閲覧モードかどうかのフラグ（true：閲覧モード／false：更新モード）
   * @param initFlag 初回フラグ
   */
  private setDisabledForWjFlexGrid(wjFlexGrid: WjFlexGrid, readOnly: boolean, initFlag: boolean) {
    if (wjFlexGrid.hostElement) {
      const forcedEnabledMode = wjFlexGrid.hostElement.getAttribute('forcedEnabledMode')
        ? wjFlexGrid.hostElement.getAttribute('forcedEnabledMode') : '';

      // 子要素のEnabledを制御する
      switch (forcedEnabledMode) {
        case 'true':
          // 『活性』 何もしない
          break;
        case 'false':
          // 『非活性』
          wjFlexGrid.selectionMode = SelectionMode.None;
          break;
        case '':
        case 'none':
          if (readOnly === true) {
            // 『非活性』
          wjFlexGrid.selectionMode = SelectionMode.None;
          } else {
            // 『活性』 なにもしない
          }
          break;
      }
    }
  }

  /**
   * データグリッド内キーダウンイベント
   * Enterキー押下時、フォーカスを縦方向に移動させる。
   *
   * @param {KeyboardEvent} e イベント
   * @param {FlexGrid} grid データグリッド
   * @param {number} col カラム番号
   * @memberof PlessViewHelperSub
   */
  public eventGridKeyDownHandler(e: KeyboardEvent, grid: FlexGrid, col: number): void {
    if (e.keyCode === 13) {
      // Enterキー押下の場合
      let nextRow: number = grid.selection.row;
      let cell: HTMLElement;
      let inputEl: HTMLInputElement;

      if (!e.shiftKey) {
        for (let rowIndex: number = grid.selection.row + 1; rowIndex < grid.rows.length; rowIndex++) {
          grid.startEditing(true, rowIndex, col, true);
          cell = grid.cells.getCellElement(rowIndex, col);
          inputEl = this.getTargetElement(cell);

          if (inputEl != null && !inputEl.disabled) {
            nextRow = rowIndex;
            break;
          }
        }
      } else {
        for (let rowIndex: number = grid.selection.row - 1; rowIndex >= 0; rowIndex--) {
          grid.startEditing(true, rowIndex, col, true);
          cell = grid.cells.getCellElement(rowIndex, col);
          inputEl = this.getTargetElement(cell);

          if (inputEl != null && !inputEl.disabled) {
            nextRow = rowIndex;
            break;
          }
        }
      }

      cell = grid.cells.getCellElement(nextRow, col);
      inputEl = this.getTargetElement(cell);

      grid.select(nextRow, -1);

      setTimeout(() => {
        grid.startEditing(true, nextRow, col, true);
        inputEl.focus();
        const curPos: number = inputEl.value.length;
        inputEl.setSelectionRange(curPos, curPos);
      }, 0);

      // デフォルトイベントをキャンセル
      e.preventDefault();
    }
  }

  /**
   * カンマ編集
   *
   * @param {*} vo
   * @param {string} bindingName
   * @param {string} text 編集対象文字列
   * @param {boolean} flag 編集フラグ(true：カンマを追加、false：カンマを削除)
   * @memberof PlessViewHelperSub
   */
  public editCommaForGridCell(vo: any, bindingName: string, text: string, flag: boolean): void {
    // カンマ編集
    text = PlessViewUtilsSub.editPriceComma(text, flag);

    // 編集結果をバインド変数に設定
    vo[bindingName] = text;
  }

  /**
   * 入力制限
   *
   * @param {HTMLInputElement} inputElement イベント発生テキストフィールド
   * @param {any} vo イベント発生オブジェクト対象VO
   * @param {string} bindingName バインド変数名
   * @param {string} text 編集対象文字列
   * @param {string} restrict 入力制限(正規表現)
   * @param {number} len 文字列の長さ
   * @memberof PlessViewHelperSub
   */
  public checkNumberRestrict(inputElement: HTMLInputElement, vo: any,
    bindingName: string, text: string, restrict: string, len: number): void {

    // バインド変数をクリア
    vo[bindingName] = '';

    // テキストフィールド内のカーソル位置を取得
    let resultIndex = inputElement.selectionStart;

    // 指定の文字列を１文字ずつに分割
    const valueArray: Array<string> = text.split('');

    // 入力制限処理結果文字列
    let retStr = String('');

    // 入力制限処理
    for (let i = Number(0); i < valueArray.length; i++) {
      // 正規表現チェック
      if (valueArray[i].match(restrict)) {                                      // 入力可能文字の場合
        // 入力可能文字だけ残す
        retStr = retStr + valueArray[i];
        // text = text + valueArray[i];
      } else {                                                                  // 入力可能文字以外の場合
        // 削除した場合はカーソル位置を調整する
        resultIndex--;
      }
    }

    // 桁数のチェック
    if (retStr.length > len) {                                                  // 指定の桁数を超過している場合
      // 指定の桁数以降は削除
      retStr = retStr.substr(0, len);
    }

    // カーソル位置のチェック
    if (resultIndex > len) {                                                    // 指定の桁数を超過している場合
      resultIndex = len - 1;
    }

    // カンマ付与
    retStr = PlessViewUtilsSub.editPriceComma(retStr, true);

    // 編集結果をバインド変数に設定
    vo[bindingName] = retStr;
  }

  public onPasting(e: any) {
    e.cancel = true;
  }

  /**
   * cdkDragConstrainPositionで呼ばれるダイアログをViewPortから隠れないようにする座標調整関数
   */
  constrainPosition = (
    _pointerPos: Point,
    dragRef: DragRef<any>,
    elementRect: ClientRect,
    _pickupPos: Point
  ): Point => {
    // ── 1) 要素サイズは elementRect から取得
    const width = elementRect.width;
    const height = elementRect.height;
    // ── 2) カーソルのウィンドウ座標から要素内で掴んだ相対座標を引いて、「要素左上が置かれるべき座標」を求める
    const rawX = _pointerPos.x - _pickupPos.x;
    const rawY = _pointerPos.y - _pickupPos.y;
    // ── 3) 残したい見える領域（handle 部分）のサイズ
    const handleWidth = 60;  // 左端に残す幅
    const handleHeight = 60;  // 上端に残す高さ
    // ── 4) ビューポートサイズ
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    // ── 5) clamp 用の最小／最大値を算出
    const minX = -width + handleWidth;
    const maxX = vw - handleWidth;
    const minY = -height + handleHeight;
    const maxY = vh - handleHeight;
    // ── 6) 移動座標を範囲内にクランプして返す
    return {
      x: Math.max(minX, Math.min(maxX, rawX)),
      y: Math.max(minY, Math.min(maxY, rawY))
    };
  }

  protected gridHeaderAlignments(
    grid: FlexGrid,
    widths: { colIdx: number, align: string }[],
    callback: (col: number, cell: HTMLElement) => void = undefined) {

    grid.itemFormatter = (panel, row, col, cell) => {
      if ((panel.cellType == CellType.ColumnHeader) && (row == 0)) {
        const w = widths.find(w => w.colIdx == col);
        cell.style.textAlign = (w ? w.align : 'left');
        if (callback) {
          callback(col, cell);
        }
      }
    }
  }
  
  protected get isPermittedFullControl() {
    return (
      this.sharedModel.FUNC_PERMISSION_FULLCONTROL === this.getFuncPermission()
    );
  }

  protected get isPermittedReadOnly() {
    return (
      this.sharedModel.FUNC_PERMISSION_READONLY === this.getFuncPermission()
    );
  }
}
